import React, { useEffect, useState } from 'react';
import RdvAffaire from "../../components/RdvAffaire";
import CardRdv from "../../components/CardRdv";


function TabsAffaireRdv(args) {
    //console.log("tabs rdv",args.transaction);
    const [rdv, setRdv] = useState(null);
    const [rdvNotaire, setRdvNotaire] = useState(null); // Stocke le RDV "Rendez vous notaire"
    const [rdvSignature, setRdvSignature] = useState(null);
    const [demandeRdv, setDemandeRdv] = useState(null);

    //get info RDV
    const getRdv = async () => {
        try {
            if (args.transaction !== null) {
                const URL = `https://api.airtable.com/v0/appD48APNaGA4GN0B/rdv?filterByFormula=SEARCH("${args.affaire.id}",{certification})`;

                fetch(
                    URL,
                    {
                        method: "GET",
                        headers: {
                            Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
                            'content-type': 'application/x-www-form-urlencoded',
                            "Accept": "application/json, text/plain, /"
                        },
                    })
                    .then((res) => res.json())
                    .then((res) => {
                        console.log("all rdv transaction", res.records);
                        const myDataSort = res.records.sort((a, b) =>
                            a.fields.sort < b.fields.sort ? -1 : 1
                        );
                        setRdv(myDataSort);
                        // 🔍 Trouver le RDV "Rendez vous notaire"
                        const rdvTrouve = res.records.find(rdv => rdv.fields.nom?.toLowerCase() === "rendez-vous notaire");
                        // ✅ Stocker les infos dans le state si trouvé
                        if (rdvTrouve) {
                            setRdvNotaire(rdvTrouve);
                        } else {
                            setRdvNotaire(null); // Aucun RDV trouvé
                        }
                        const rdvSignatureTrouve = res.records.find(r => r.fields.nom?.toLowerCase() === "rendez-vous de signature");
                        setRdvSignature(rdvSignatureTrouve || null);
                    })
                    .catch((error) => console.log(error));
            }
        } catch (e) {
            console.log(e);
        }
    };

    //get info RDV
    const getDemandeRdv = async () => {
        try {
            if (args.transaction !== null) {
                const URL = `https://api.airtable.com/v0/appD48APNaGA4GN0B/demande_rdv?filterByFormula=SEARCH("${args.affaire.id}",{id_affaire})`;

                fetch(
                    URL,
                    {
                        method: "GET",
                        headers: {
                            Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
                            'content-type': 'application/x-www-form-urlencoded',
                            "Accept": "application/json, text/plain, /"
                        },
                    })
                    .then((res) => res.json())
                    .then((res) => {
                        console.log("all demande_rdv transaction", res.records);
                        const myDataSort = res.records.sort((a, b) =>
                            a.fields.sort < b.fields.sort ? -1 : 1
                        );
                        setDemandeRdv(myDataSort);
                    })
                    .catch((error) => console.log(error));
            }
        } catch (e) {
            console.log(e);
        }
    };
    //get info RDV
    useEffect(() => {
        //get info rdv
        getRdv();
        getDemandeRdv();

    }, [args.transaction]);


    console.log("demande", demandeRdv)
    
    if (rdv !== null && demandeRdv !== null) {
        return (
            <>
                <div>
                    <RdvAffaire type="certification" idAffaire={args.affaire.id} notaireAirtableId={args.affaire.notaire[0]} affaire={args.affaire} rdvNotaire={rdvNotaire} rdvSignature={rdvSignature} refreshData={getRdv} />

                    {/** demande de rdv */}
                    {demandeRdv.length > 0 && (
                        <CardRdv
                                                    date_creation={demandeRdv[0].fields?.date_creation}
                                                    date={demandeRdv[0].fields?.date}
                                                    heure_debut={demandeRdv[0].fields?.heure_debut}
                                                    heure_fin={demandeRdv[0].fields?.heure_fin}
                                                    type_rdv={demandeRdv[0].fields?.type}
                                                    statut={demandeRdv[0].fields?.statut}
                                                    id={demandeRdv[0].id}
                                                />
                    )}
                </div>
            </>
        );
    }
    return (<></>)
}

export default TabsAffaireRdv;
